import { Component, OnInit } from '@angular/core';
import { Tabs } from './tabs';

@Component({
  selector: 'ngx-contribution',
  template: `<ngx-one-column-layout>
               <router-outlet></router-outlet>
            </ngx-one-column-layout>`,
  styleUrls: ['./contribution.component.scss']
})
export class ContributionLayoutComponent implements OnInit {

  tabs = Tabs;

  constructor() { }

  ngOnInit(): void {}

}
